import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "./../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from './customCheckButton/radioCheckButton.js';
import RadioCheckButtonCustom from '../../../shared/items/controls/radioCheckButton';
import StepContentWrapper from "./../stepContentWrapper"
import { sexData } from "../sex/static.sexData"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "./../../../shared/services/service.step"
import { oldData } from "./static.oldData"
import { steps } from "./../../../shared/static.steps"
import locales from "./../../../content.json"
import store from './../../../store'

import s from './old.module.scss'
import "./../../../shared/services/service.step.scss"

class Old extends Component {
  constructor() {
    super();

    this.state = {
      isOpenOld: false,
    }
  }

  componentDidMount() {
    console.log('log')
    console.log(this.props)
    if (isCurrentStep(this.props.currentIndex, steps.old) && !this.state.isOpenOld)
      this.setState({ isOpenOld: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, onSetStepData, data } = this.props
    const { isOpenOld } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.old,
      isOpen: isOpenOld,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenOld && !has(data, ["old"]))
      onSetStepData("old")

    if (isOpenOld && has(data, ["old"])) {
      // this.props.onToNextStep();
    }

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenOld: state,
    })
  }

  render() {
    let isAgeAbtest = store.getState().appState.isAgeAbtest;
    let isAgeManTest = store.getState().appState.isAgeManTest;
    let isAgeTest = isAgeAbtest || isAgeManTest;

    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenOld } = this.state
    const params = {
      className: "wrapperOld",
      currentIndex: currentIndex,
      stepIndex: steps.old,
    }

    return isOpenOld ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].age_ask}</FirstTitle>

          { isAgeTest &&
            <div className={s.description}>{locales[window.userLang].age_description}</div>
          }

          <div className={s.optionsWrapper}>
          {
            Object.keys(oldData).map((key, index) => {
              return (
                isAgeTest ?
                <RadioCheckButton
                  key={index}
                  isChecked={get(data, ["old", "value"], null) === oldData[key].value}
                  onClick={() => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      'event': 'step1-age',
                      'onb_answer_varB': get(oldData, [key, "title"]),
                    });

                    if (get(data, ["old", "value"], null) !== oldData[key].value){
                      isAgeManTest 
                        ? onUpdateStepData.bind(this, "sex", "value", "male")()
                        : onUpdateStepData.bind(this, "sex", "value", "female")()
                      onUpdateStepData.bind(this, "old", "value", get(oldData, [key, "value"]))();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                >
                  {isAgeManTest 
                  ? <img src={oldData[key].imgMale} alt="male"/>
                  : <img src={oldData[key].imgFemale} alt="female"/>}
                  <div className={s.age}>{oldData[key].title}</div>
                </RadioCheckButton> :
                <RadioCheckButtonCustom
                key={index}
                isChecked={get(data, ["old", "value"], null) === oldData[key].value}
                onClick={() => {
                  if (get(data, ["old", "value"], null) !== oldData[key].value){
                    onUpdateStepData.bind(this, "old", "value", get(oldData, [key, "value"]))();
                    setTimeout(this.props.onToNextStep, 300);
                  }
                }}
              >
                {oldData[key].title}
              </RadioCheckButtonCustom>
              )
            })
          }
          </div>
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(Old);